module.exports = __webpack_public_path__ + "static/InteriorLandingHeroLiving_mobile-min-fa3dd2be57b40683746008c7aa20ffcb.jpg";